export default "__VITE_ASSET__BO0aqGQg__"